
<div class="w-full flex flex-col items-center p-2 md:p-x-4 md:p-b-4">
    <div class="w-full text-2xl mb-2">
        {{info.name}}
    </div>
    <mat-divider class="w-full"></mat-divider>
    <div id="editor" #editor style="width: 100%;"></div>
</div>
<div class="w-full p-4 pb-0 flex place-content-end">
    <button mat-stroked-button [mat-dialog-close]="true">
        <span>Fermer</span>    
    </button>
      
</div>